function API_URL() {
    if (process.env.NODE_ENV === "development") {
        return "https://dev-www.addcampus.com";
    } else {
        return "https://addcampus.com";
    }
}

function ADDY_URL() {
    if (process.env.NODE_ENV === "development") {
        return "https://dev-addy.addcampus.com";
    } else {
        return "https://addy.addcampus.com";
    }
}


const calResult = (gentle, flex, forgive, patience) => {
    let total_point = gentle + flex + forgive + patience;
    let obj_arr = [
        {weight: "gentle", point: gentle},
        {weight: "flex", point: flex},
        {weight: "forgive", point: forgive},
        {weight: "patience", point: patience},
    ]
    let res_2 = obj_arr.sort(function (a, b) {
        return a.point > b.point ? -1 : a.point < b.point ? 1 : 0;
    });

    let result;
    let avg_point = total_point / 4;
    let avg_minus_a = avg_point - res_2[0].point;
    let avg_minus_b = avg_point - res_2[1].point;
    let avg_minus_c = avg_point - res_2[2].point;
    let avg_minus_d = avg_point - res_2[3].point;

    if (avg_minus_a < 0) {
        avg_minus_a = -avg_minus_a
    }
    if (avg_minus_b < 0) {
        avg_minus_b = -avg_minus_b
    }
    if (avg_minus_c < 0) {
        avg_minus_c = -avg_minus_c
    }
    if (avg_minus_d < 0) {
        avg_minus_d = -avg_minus_d
    }

    if (avg_minus_a < 0.75 && avg_minus_b < 0.75 && avg_minus_c < 0.75 && avg_minus_d < 0.75) {
        result = 10 // 무성향
    } else {
        if (res_2[0].point - res_2[1].point > 2) {
            if (res_2[0].weight === 'gentle') {
                result = 0; // 온유 온유
            } else if (res_2[0].weight === 'flex') {
                result = 4; // 융통 융통
            } else if (res_2[0].weight === 'forgive') {
                result = 7; // 관용 관용
            } else if (res_2[0].weight === 'patience') {
                result = 9; // 인내 인내
            }
        } else {
            if (res_2[1].point === res_2[2].point) {
                if (res_2[0].weight === 'gentle') {
                    if (res_2[1].weight === 'flex') {
                        result = 1; // 온유 융통
                    } else {
                        if (res_2[2].weight === 'flex') {
                            result = 1; // 온유 융통
                        } else {
                            result = 0; // 온유 온유
                        }
                    }

                } else if (res_2[0].weight === 'flex') {
                    if (res_2[1].weight === 'gentle') {
                        result = 1; // 온유 융통
                    } else {
                        if (res_2[2].weight === 'gentle') {
                            result = 1; // 온유 융통
                        } else {
                            result = 4; // 융통 융통
                        }
                    }
                } else if (res_2[0].weight === 'forgive') {
                    if (res_2[1].weight === 'patience') {
                        result = 8; // 관용 인내
                    } else {
                        if (res_2[2].weight === 'patience') {
                            result = 8; // 관용 인내
                        } else {
                            result = 7; // 관용 관용
                        }
                    }
                } else if (res_2[0].weight === 'patience') {
                    if (res_2[1].weight === 'forgive') {
                        result = 8; // 관용 인내
                    } else {
                        if (res_2[2].weight === 'forgive') {
                            result = 8; // 관용 인내
                        } else {
                            result = 9; // 인내 인내
                        }
                    }
                }
            } else {
                if ((res_2[0].weight === 'gentle' && res_2[1].weight === 'flex') || (res_2[0].weight === 'flex' && res_2[1].weight === 'gentle')) {
                    result = 1; // 온유 융통
                } else if ((res_2[0].weight === 'gentle' && res_2[1].weight === 'forgive') || (res_2[0].weight === 'forgive' && res_2[1].weight === 'gentle')) {
                    result = 2; // 온유 관용
                } else if ((res_2[0].weight === 'gentle' && res_2[1].weight === 'patience') || (res_2[0].weight === 'patience' && res_2[1].weight === 'gentle')) {
                    result = 3; // 온유 인내
                } else if ((res_2[0].weight === 'flex' && res_2[1].weight === 'forgive') || (res_2[0].weight === 'forgive' && res_2[1].weight === 'flex')) {
                    result = 5; // 융통 관용
                } else if ((res_2[0].weight === 'flex' && res_2[1].weight === 'patience') || (res_2[0].weight === 'patience' && res_2[1].weight === 'flex')) {
                    result = 6; // 융통 인내
                } else if ((res_2[0].weight === 'forgive' && res_2[1].weight === 'patience') || (res_2[0].weight === 'patience' && res_2[1].weight === 'forgive')) {
                    result = 8; // 관용 인내
                }
            }
        }
    }
    return result
}

module.exports = {
    API_URL: API_URL(),
    IMG_URL: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com",
    ADDY_URL: ADDY_URL(),
    calResult: calResult,
}
